var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99828 13.2533C10.0249 13.4533 9.95828 13.6667 9.80494 13.8067C9.54494 14.0667 9.12494 14.0667 8.86494 13.8067L6.19161 11.1333C6.03828 10.98 5.97161 10.7733 5.99828 10.58V7.16667L2.80494 3.08C2.57828 2.79333 2.63161 2.37333 2.91828 2.14667C3.04494 2.05333 3.18494 2 3.33161 2H12.6649C12.8116 2 12.9516 2.05333 13.0783 2.14667C13.3649 2.37333 13.4183 2.79333 13.1916 3.08L9.99828 7.16667V13.2533ZM4.69161 3.33333L7.33161 6.70667V10.3867L8.66494 11.72V6.7L11.3049 3.33333H4.69161Z",
    fill: "#2D4B9F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOutlined);
export default __webpack_public_path__ + "static/media/filter_outlined.f0b325152db1e2dba857e87ab3fed08e.svg";
export { ForwardRef as ReactComponent };